import React from "react";
import { ReactComponent as TNDistrictsMap } from "../assets/tamil-nadu-districts.svg";

interface CoverageMapProps {
  badge: string;
  title: string;
  titleHighlight: string;
  subtitle: string;
  legendActive: string;
  legendOpen: string;
  attribution: string;
}

const CoverageMap = ({
  badge,
  title,
  titleHighlight,
  subtitle,
  legendActive,
  legendOpen,
  attribution,
}: CoverageMapProps) => {
  return (
    <section className="py-14 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="reveal text-center mb-10 lg:mb-14">
          <div className="inline-flex items-center gap-2 bg-secondary-100 text-secondary-700 rounded-full px-4 py-2 text-sm font-semibold mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-600 inline-block"></span>
            {badge}
            <span className="w-1.5 h-1.5 rounded-full bg-primary-600 inline-block"></span>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight">
            <span className="block mb-3">{title}</span>
            <span className="gradient-text">{titleHighlight}</span>
          </h2>
          <p className="text-base lg:text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed">{subtitle}</p>
        </div>

        <div className="reveal flex justify-center">
          <TNDistrictsMap
            role="img"
            aria-label="Map of Tamil Nadu districts, with Salem highlighted as APlus Healthcare's first outlet"
            className="w-full max-w-md h-auto"
          />
        </div>

        <div className="reveal mt-8 flex flex-wrap items-center justify-center gap-6 sm:gap-10">
          <div className="flex items-center gap-2">
            <span className="w-4 h-4 rounded-full bg-primary-600 inline-block flex-shrink-0"></span>
            <span className="text-gray-700 text-sm font-medium">{legendActive}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-4 h-4 rounded-full bg-white border-2 border-gray-300 inline-block flex-shrink-0"></span>
            <span className="text-gray-700 text-sm font-medium">{legendOpen}</span>
          </div>
        </div>

        <p className="mt-6 text-center text-gray-400 text-xs">{attribution}</p>
      </div>
    </section>
  );
};

export default CoverageMap;
